import { Component, ElementRef, EventEmitter, Input, OnInit, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ReportFilter } from 'src/app/data/model/reportFilter';
import { UserService } from 'src/app/data/service/user.service';
import { SidebarType } from 'src/app/modules/bookkeeping/enums/sidebar-type';

@Component({
  selector: 'app-pagesidebar',
  templateUrl: './page-sidebar.component.html',
  styleUrls: ['./page-sidebar.component.scss']
})
export class PageSidebarComponent implements OnInit, OnDestroy {
  @Input() savedFilters: ReportFilter[] = [];
  @Input() isInbox: boolean = false;
  @Input() isBillsToPay: boolean = false;
  @Input() invoiceCount: number = 0;
  @Input() showSubmitterColumn: boolean = true;
  @Output() changeTabEvent = new EventEmitter<string>();
  @Output() changeFilterEvent = new EventEmitter<ReportFilter>();
  @Output() closeFilter = new EventEmitter<ReportFilter>();
  @Output() addFilter = new EventEmitter<any>();
  @Output() toggleSidebarEvt = new EventEmitter<SidebarType>();
  @Output() searchEvt = new EventEmitter<any>();
  @Output() toggleSubmitterColumnEvent = new EventEmitter<boolean>();
  
  displaySavedFilters: ReportFilter[] = [];
  isSidebar: boolean = true;
  isProcessedTab: boolean = false;
  isInProcessingTab: boolean = true;
  isProcessingError: boolean = false;
  isBillsToPayTab: boolean = true;
  isPaymentsTab: boolean = false;
  types = SidebarType;
  isShowMore: boolean = false;
  isShowLess: boolean = false;
  roleId: string;
  showToolTipDelay = 500;
  private resizeHandler: () => void;

  @ViewChild('searchtext') searchInput: ElementRef;

  constructor(private userService: UserService) {
    this.initializeState();
  }

  private initializeState() {
    //this.roleId = localStorage.getItem("roleId") || '';
    this.userService.getUserGetByIdServer().subscribe(response => {
      if (response && response.data) {
        this.roleId = response.data.role.toString();
      }
    });
    this.isSidebar = window.innerWidth >= 600;
  }

  ngOnInit() {
    this.initializeState();
    
    // Set up resize handler
    this.resizeHandler = () => {
      const wasVisible = this.isSidebar;
      const shouldBeVisible = window.innerWidth >= 600;
      
      // Only update if the visibility should change
      if (wasVisible !== shouldBeVisible) {
        this.isSidebar = shouldBeVisible;
      }
    };
    
    // Listen for window resize events
    window.addEventListener('resize', this.resizeHandler);
  }

  ngOnDestroy() {
    // Clean up resize listener
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.savedFilters?.currentValue) {
      this.savedFilters = changes.savedFilters.currentValue;
      this.updateDisplayFilters();
    }
  }

  private updateDisplayFilters() {
    this.displaySavedFilters = this.savedFilters.slice(0, 5);
    this.isShowMore = this.savedFilters.length > 5;
    this.isShowLess = false;
  }

  showMore() {
    this.displaySavedFilters = this.savedFilters;
    this.isShowMore = false;
    this.isShowLess = true;
  }

  showLess() {
    this.updateDisplayFilters();
  }

  changeTab(value: string) {
    // Reset all tabs first
    this.isInProcessingTab = false;
    this.isProcessedTab = false;
    this.isProcessingError = false;
    this.isBillsToPayTab = false;

    // Set the active tab
    switch (value) {
      case 'InProcessing':
        this.isInProcessingTab = true;
        break;
      case 'Processed':
        this.isProcessedTab = true;
        break;
      case 'ProcessingError':
        this.isProcessingError = true;
        break;
      case 'BillsToPay':
        this.isBillsToPayTab = true;
        break;
    }

    this.changeTabEvent.emit(value);
  }

  addFilters() {
    this.addFilter.emit();
  }

  selectFilters(filter: ReportFilter) {
    let index = this.savedFilters.findIndex(x => x.checked == true);
    if (index == -1) {
      filter.checked = true;
      this.changeFilterEvent.emit(filter);
    }
    else if (index >= 0 && (filter.checked == undefined || filter.checked == false)) {
      this.savedFilters[index].checked = false;
      filter.checked = true;
      this.changeFilterEvent.emit(filter);
    }
    else {
      filter.checked = false;
      this.closeFilter.emit(filter);
    }
  }

  updateSavedFilters(filter) {
    this.savedFilters = Object.assign({}, filter);
  }

  toggleSidebar(sidebar: SidebarType) {
    this.toggleSidebarEvt.emit(sidebar);
  }

  onSearchChange(event: any): void {
    this.searchEvt.emit(event);
  }

  toggleSubmitterColumn() {
    this.showSubmitterColumn = !this.showSubmitterColumn;
    this.toggleSubmitterColumnEvent.emit(this.showSubmitterColumn);
  }
}